export default __webpack_public_path__ + "static/media/HTN.f3443efa.png";